import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {CoachApi, ReplicationEndpoint, ReplicationEndpointApi, ReplicationEndpointInterface} from '@derena/api';

@Injectable({ providedIn: 'root' })
export class EndpointInterceptor implements HttpInterceptor {
    private endpoint: ReplicationEndpoint;
    private session: string;
    private changeStream = new Subject<EndpointInterceptor>();

    constructor(private endpointApi: ReplicationEndpointApi, private coachApi: CoachApi) { }

    get name(): string {
        return 'MO-RENA';
    }

    get url(): string {
        if (!this.endpoint)
            return null;
        return `${this.endpoint.protocol}://${this.endpoint.host}:${this.endpoint.port}`
    }

    get valid(): boolean {
        return !!this.session;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.session)
            return next.handle(req);

        req.headers.append('Cookie', `AuthSession=${this.session}`);
        req.headers.append('X-Replication-Endpoint', this.session);

        return next.handle(req);
    }

    async updateSession() {
        this.session = await this.coachApi.connect(null).toPromise();
        this.changeStream.next(this);
    }

    async init(endpointId: string) {
        this.endpoint = new ReplicationEndpoint(
            await this.endpointApi.findById<ReplicationEndpointInterface>(endpointId).toPromise()
        );
        this.changeStream.next(this);
    }

    async getSession(): Promise<string> {
        if (this.session)
            return this.session;

        await this.updateSession();
        return this.session;
    }

    changes(): Observable<EndpointInterceptor> {
        return this.changeStream.asObservable();
    }
}
